import { companiesCompanyIdCustomDomains } from "@dashboardApi/apis/companiesCompanyIdCustomDomains";
import { companiesCompanyIdCustomDomainsDomainTypeDomainId } from "@dashboardApi/apis/companiesCompanyIdCustomDomainsDomainTypeDomainId";

import type { AllRouteEndpoints } from "../routeTypes";

export const postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdCustomDomains,
  companiesCompanyIdCustomDomainsDomainTypeDomainId,
];
